<div class="app-main">
  <div class="app-breadcrumb">
    <span class="bc-link" (click)="goToCompanies()">Empresas</span>
    <span class="bc-sep">›</span>
    <span class="bc-link" (click)="goToBranches()">{{ company()?.name || '...' }}</span>
    <span class="bc-sep">›</span>
    <span class="bc-current">{{ branch()?.name || 'Dashboard' }}</span>
  </div>

  <!-- Selector de cámara -->
  @if (sources().length > 0) {
    <div class="source-selector">
      <button
        class="source-pill"
        [class.active]="isUniversal()"
        (click)="selectSource(null)"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="currentColor" viewBox="0 0 16 16">
          <path d="M1 2.828c.885-.37 2.154-.769 3.388-.893 1.33-.134 2.458.063 3.112.752v9.746c-.935-.53-2.12-.603-3.213-.493-1.18.12-2.37.461-3.287.811V2.828zm7.5-.141c.654-.689 1.782-.886 3.112-.752 1.234.124 2.503.523 3.388.893v9.923c-.918-.35-2.107-.692-3.287-.81-1.094-.111-2.278-.039-3.213.492V2.687zM8 1.783C7.015.936 5.649.655 4.12.63c-1.906-.031-4.189.694-5.12 1.015V13.19c.931-.32 3.214-1.046 5.12-1.015 1.53.025 2.895.305 3.88 1.152z"/>
        </svg>
        Global
      </button>

      @for (source of sources(); track source.idSource) {
        <button
          class="source-pill"
          [class.active]="selectedSource()?.idSource === source.idSource"
          (click)="selectSource(source)"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="currentColor" viewBox="0 0 16 16">
            <path d="M0 5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5zm1.5 0v6a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V5a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5z"/>
            <path d="M2 6a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11A.5.5 0 0 1 2 6zm.5 2.5a.5.5 0 0 0 0 1H5a.5.5 0 0 0 0-1H2.5z"/>
          </svg>
          {{ source.name }}
        </button>
      }
    </div>
  }

  <!-- Selector de fecha -->
  <div class="date-selector">
    <label class="date-chip" for="dashDate">
      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
        <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>
      </svg>
      <span class="date-chip-label">Fecha</span>
      <span class="date-chip-sep" aria-hidden="true"></span>
      <input
        id="dashDate"
        type="date"
        class="date-chip-input"
        [max]="todayISO"
        [value]="selectedDate()"
        (change)="onDateChange($any($event.target).value)"
      />
    </label>
  </div>

  @if (loading()) {
    <div class="loading-state">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Cargando...</span>
      </div>
      <p>Cargando dashboard...</p>
    </div>
  } @else if (error()) {
    <div class="empty-state">
      <p class="text-danger">{{ error() }}</p>
    </div>
  } @else {
    <div class="chart-rows">

      <!-- KPI Cards -->
      <div class="kpi-grid">
        <div class="stat-card">
          <div class="stat-card-inner">
            <div>
              <div class="stat-label">Personas hoy</div>
              <div class="stat-value">{{ dashboard()?.totalPeopleToday ?? 0 }}</div>
              <div class="stat-unit">personas detectadas</div>
            </div>
            <div class="stat-icon" style="background:rgba(59,130,246,0.12);color:#3B82F6">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7Zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"/>
                <path fill-rule="evenodd" d="M5.216 14A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216Z"/>
                <path d="M4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"/>
              </svg>
            </div>
          </div>
        </div>

        <div class="stat-card">
          <div class="stat-card-inner">
            <div>
              <div class="stat-label">Tiempo promedio</div>
              <div class="stat-value">{{ avgDurationFormatted() }}</div>
              <div class="stat-unit">tiempo en local (hoy)</div>
            </div>
            <div class="stat-icon" style="background:rgba(245,158,11,0.12);color:#F59E0B">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                <path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"/>
                <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z"/>
              </svg>
            </div>
          </div>
        </div>

        <div class="stat-card">
          <div class="stat-card-inner">
            <div>
              <div class="stat-label">Hora pico</div>
              <div class="stat-value" style="font-size:1.4rem">{{ peakHour() }}</div>
              <div class="stat-unit">{{ peakHourCount() }} personas en esa hora</div>
            </div>
            <div class="stat-icon" style="background:rgba(16,185,129,0.12);color:#10B981">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M10.293 1.5a1 1 0 0 1 1.414 0l2.5 2.5a1 1 0 0 1 0 1.414l-7.5 7.5a1 1 0 0 1-.707.293H3.5a1 1 0 0 1-1-1V9.5a1 1 0 0 1 .293-.707l7.5-7.5z"/>
              </svg>
            </div>
          </div>
        </div>
      </div>

      <!-- Chart row 1: por hora + semana -->
      <div class="chart-grid">
        <div class="chart-card">
          <div class="chart-title">Personas por hora — Hoy</div>
          <div #barChart style="height:260px;width:100%"></div>
        </div>
        <div class="chart-card">
          <div class="chart-title">Personas por día — Semana actual</div>
          @if ((dashboard()?.weekly?.length ?? 0) === 0) {
            <div class="empty-state" style="padding:2rem"><p>Sin datos esta semana</p></div>
          } @else {
            <div #lineChart style="height:260px;width:100%"></div>
          }
        </div>
      </div>

      <!-- Hora pico por día de la semana (full width) -->
      <div class="chart-card">
        <div class="chart-title">Hora pico por día de la semana</div>
        <div #peakChart style="height:260px;width:100%"></div>
      </div>

      <!-- Chart row 2: mensual + por cámara (solo en global) -->
      @if (isUniversal()) {
        <div class="chart-grid">
          <div class="chart-card">
            <div class="chart-title">Tendencia mensual — Últimos 30 días</div>
            @if ((dashboard()?.monthly?.length ?? 0) === 0) {
              <div class="empty-state" style="padding:2rem"><p>Sin datos del mes</p></div>
            } @else {
              <div #monthlyChart style="height:260px;width:100%"></div>
            }
          </div>
          <div class="chart-card">
            <div class="chart-title">Personas por cámara — Hoy</div>
            @if ((dashboard()?.bySource?.length ?? 0) === 0) {
              <div class="empty-state" style="padding:2rem"><p>Sin datos por cámara</p></div>
            } @else {
              <div #sourceChart style="height:260px;width:100%"></div>
            }
          </div>
        </div>
      } @else {
        <div class="chart-card">
          <div class="chart-title">Tendencia mensual — Últimos 30 días</div>
          @if ((dashboard()?.monthly?.length ?? 0) === 0) {
            <div class="empty-state" style="padding:2rem"><p>Sin datos del mes</p></div>
          } @else {
            <div #monthlyChart style="height:260px;width:100%"></div>
          }
        </div>
      }

      <!-- Heatmap full width -->
      <div class="chart-card">
        <div class="chart-title">Mapa de calor — Hora × Día (últimas 8 semanas)</div>
        <div #heatmapChart style="height:200px;width:100%"></div>
      </div>

    </div>
  }
</div>
